import React, { ElementType, useState } from 'react'
import * as S from './index.style'
import TextField from '@material-ui/core/TextField'
import { InputBaseComponentProps } from '@material-ui/core'
import { DadosLoteadora, ValidacaoDadosLoteadora } from 'models/Viabilidade/Loteadora'
import { MascaraDecimal } from 'components/Mascara/Decimal'
import Grid from 'components/Grid'

export type CardLoteadoraProps = {
  /** Descricao do que a prop faz, vai direto pro storybook */
  dadosLoteadora: DadosLoteadora
  dadosLoteadoraHandler: (novoValor: DadosLoteadora) => void
}

/** Descricao do que o componente faz, vai direto pro storybook */
const CardLoteadora: React.FC<CardLoteadoraProps> = ({ dadosLoteadora, dadosLoteadoraHandler }) => {
  const [valores, setValores] = useState(dadosLoteadora)
  const [mensagensErro, setMensagensErro] = useState(new ValidacaoDadosLoteadora())

  const precoLoteHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValores({ precoLote: event.target.value, valido: false })
    dadosLoteadoraHandler({ precoLote: event.target.value, valido: false })
  }

  const validarPrecoLote = () => {
    const erroPrecoLote = mensagensErro.validarPrecoLote(valores.precoLote.toString())

    const validador = new ValidacaoDadosLoteadora(erroPrecoLote)

    setMensagensErro(validador)
    validarCard(validador)
  }

  const validarCard = (validador: ValidacaoDadosLoteadora) => {
    const state = { ...valores } as DadosLoteadora

    state.valido = validador.validarTodosCampos(state)
    setValores(state)
    dadosLoteadoraHandler(state)
  }

  return (
    <S.Wrapper>
      <Grid orientacao="column" gridTemplateColumns=".25fr" gridGap="32px">
        <div>
          <S.Label>Preço do Lote da Casa (R$/unid)</S.Label>
          <TextField
            required
            placeholder="0.000,00"
            type="text"
            name="precoLote"
            data-cy="campoPrecoLote"
            value={valores.precoLote}
            onChange={precoLoteHandler}
            onBlur={validarPrecoLote}
            variant="outlined"
            size="small"
            InputProps={{
              inputComponent: MascaraDecimal as unknown as ElementType<InputBaseComponentProps>
            }}
            error={mensagensErro.precoLote != ''}
            helperText={mensagensErro.precoLote}
          />
        </div>
      </Grid>
    </S.Wrapper>
  )
}

export default CardLoteadora
